import React from 'react';
import { TableCell } from '@material-ui/core';

export default props => {
  let { cellContent, ...rest } = props;
  return <TableCell {...rest}>{props.cellContent}</TableCell>;
};



// WEBPACK FOOTER //
// ./src/components/Table/TableCell.jsx